export interface ImageSize {
	width: number
	height: number
}

// Null when the browser cannot decode it, so callers store no size rather than a wrong one.
export const readImageSize = (
	source: Blob | string,
): Promise<ImageSize | null> =>
	new Promise((resolve) => {
		const objectUrl =
			typeof source === "string" ? null : URL.createObjectURL(source)
		const img = new Image()
		const finish = (size: ImageSize | null) => {
			if (objectUrl) URL.revokeObjectURL(objectUrl)
			resolve(size)
		}
		img.onload = () =>
			finish(
				img.naturalWidth > 0 && img.naturalHeight > 0
					? { width: img.naturalWidth, height: img.naturalHeight }
					: null,
			)
		img.onerror = () => finish(null)
		img.src = objectUrl ?? (source as string)
	})
